import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { useToast } from '../../components/Toast';

interface LinhaCatalogo {
  id: string;
  fornecedor_id: number;
  fornecedor_nome: string | null;
  codigo_fornecedor: string | null;
  descricao_fornecedor: string | null;
  marca: string | null;
  embalagem: string | null;
  quantidade_embalagem: string | number | null;
  preco_unitario: string | number | null;
  origem: string | null;
}

function fmtQtd(v: string | number | null): string {
  if (v == null || v === '') return '—';
  return Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 4 });
}

function fmtPreco(v: string | number | null): string {
  if (v == null || v === '' || Number(v) === 0) return '—';
  return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function SecaoCotacoesCatalogo({ produtoId }: { produtoId: number }) {
  const toast = useToast();
  const [lista, setLista] = useState<LinhaCatalogo[] | null>(null);

  useEffect(() => {
    let cancelado = false;
    api.get<LinhaCatalogo[]>(`/api/fornecedor-catalogo/historico/${produtoId}`)
      .then((r) => {
        if (cancelado) return;
        // So o catalogo do fornecedor; respostas de cotacao (inclusive as em branco) ficam fora desta aba.
        const soCatalogo = r.filter((l) => l.origem === 'catalogo');
        // Preco asc; linhas sem preco (0/null) vao pro fim em vez de fingir ser as mais baratas.
        const ord = (l: LinhaCatalogo) => {
          const n = Number(l.preco_unitario);
          return n > 0 ? n : Number.POSITIVE_INFINITY;
        };
        setLista([...soCatalogo].sort((a, b) => ord(a) - ord(b)));
      })
      .catch((e: any) => { if (!cancelado) { setLista([]); toast.erro(e.message); } });
    return () => { cancelado = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produtoId]);

  if (lista === null) {
    return <div className="text-sm text-gray-400 text-center py-6">Carregando...</div>;
  }
  if (lista.length === 0) {
    return <div className="text-sm text-gray-500 italic">Nenhum fornecedor catalogou este produto.</div>;
  }

  return (
    <div>
      <p className="text-xs text-gray-500 mb-2">
        Tudo que cada fornecedor catalogou para este produto. Ordenado do menor preco para o maior.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-300 text-left text-xs uppercase text-gray-600">
              <th className="py-2 pr-4 font-semibold">Fornecedor</th>
              <th className="py-2 pr-4 font-semibold">Cod. Fornecedor</th>
              <th className="py-2 pr-4 font-semibold">Descricao do Fornecedor</th>
              <th className="py-2 pr-4 font-semibold">Embalagem</th>
              <th className="py-2 pr-4 font-semibold text-right">Qtd na Embalagem</th>
              <th className="py-2 pr-4 font-semibold">Marca</th>
              <th className="py-2 pr-4 font-semibold text-right">Preco Emb (R$)</th>
            </tr>
          </thead>
          <tbody>
            {lista.map((l) => (
              <tr key={l.id} className="border-b border-gray-100">
                <td className="py-2 pr-4">{l.fornecedor_nome || '—'}</td>
                <td className="py-2 pr-4">
                  {l.codigo_fornecedor
                    ? <span className="codigo-curto">{l.codigo_fornecedor}</span>
                    : '—'}
                </td>
                <td className="py-2 pr-4">{l.descricao_fornecedor || '—'}</td>
                <td className="py-2 pr-4">{l.embalagem || '—'}</td>
                <td className="py-2 pr-4 text-right">{fmtQtd(l.quantidade_embalagem)}</td>
                <td className="py-2 pr-4">{l.marca || '—'}</td>
                <td className="py-2 pr-4 text-right font-medium">{fmtPreco(l.preco_unitario)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
